<template lang="">
  <div class="content-header">
    <div class="no-head">{{ no }}</div>
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    no: String,
  },
};
</script>
<style scoped lang="scss">
.content-header {
  padding-top: 2rem;
  align-items: center;

  .title {
    width: 100%;
  }
  display: flex;
}
</style>
